import { FC } from "react";
import { Command } from "@vendor/cmdk/cmdk";
import { pluralizeWithCount } from "@common/helpers/string";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { CommandsListProps } from "./lib";

export const CloseTemplateBulkCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const {
        selectedCloseTemplateCount = 0,
        onCloseTemplateBulkArchive,
        onCloseTemplateBulkUnarchive,
        onCloseTemplateBulkDelete,
    } = options;

    const heading = `${pluralizeWithCount("template", selectedCloseTemplateCount)} selected`;

    return (
        <Command.Group heading={heading}>
            {onCloseTemplateBulkArchive && (
                <CommandItem
                    keywords={["archive"]}
                    onSelect={onCloseTemplateBulkArchive}
                >
                    Archive
                </CommandItem>
            )}
            {onCloseTemplateBulkUnarchive && (
                <CommandItem
                    keywords={["activate", "unarchive", "restore"]}
                    onSelect={onCloseTemplateBulkUnarchive}
                >
                    Activate
                </CommandItem>
            )}
            {onCloseTemplateBulkDelete && (
                <CommandItem
                    keywords={["delete", "remove"]}
                    shortcut="delete"
                    onSelect={onCloseTemplateBulkDelete}
                >
                    Delete
                </CommandItem>
            )}
        </Command.Group>
    );
};
